import { type FC, useState } from 'react';
import { useDispatch } from 'react-redux';
import { ListGroup } from 'react-bootstrap';

import {
	type MCQuestion,
	type MCQuestionPoolPayload,
	type PageElement,
	ElementType
} from '@editor2/types/pageElements';
import { addElementToPage, deleteElementFromPage } from '@editor2/reducers/editor/editorSlice';
import { copyElement, getNewElement, isDoubleElement } from '@editor2/services/elementService';
import GenerateQuestionsModal from '@editor2/components/GenerateQuestionsModal';

interface Props {
	courseId: number;
	pageId: string;
	element: PageElement;
	index: number;
	onDropdownHide: () => void;
}

const ElementDropdown: FC<Props> = (props) => {
	const { element, pageId, courseId, index, onDropdownHide } = props;

	const [isGenerateQuestionsModalShown, setGenerateQuestionsModalShown] = useState(false);

	const dispatch = useDispatch();

	const duplicateElement = () => {
		const { id, ...elementAttributes } = element;

		const elementCopy = copyElement(elementAttributes);

		dispatch(addElementToPage({ pageId, elementEntity: elementCopy, index: index + 1, courseId }));
	};

	const convertMCQuestionToQuestionPool = () => {
		const { indent, initPageId, metadata, ...mcQuestion } = element as MCQuestion;

		const mcQuestionPool: MCQuestionPoolPayload = {
			...(getNewElement('MCQuestionPool') as MCQuestionPoolPayload),
			questions: [copyElement(mcQuestion)],
			metadata: (element as MCQuestion).metadata
		};

		dispatch(
			addElementToPage({ pageId, elementEntity: mcQuestionPool, index: index + 1, courseId })
		);
		dispatch(deleteElementFromPage({ pageId, elementId: element.family_id, courseId }));
	};

	const generateQuestions = () => {
		setGenerateQuestionsModalShown(true);
	};

	return (
		<>
			<ListGroup className="elementDropdown">
				{element.type === ElementType.MCQuestion && (
					<ListGroup.Item
						className="dropdownItem"
						onClick={() => convertMCQuestionToQuestionPool()}>
						Convert to Pool
					</ListGroup.Item>
				)}

				{!isDoubleElement(element.type) && (
					<ListGroup.Item className="dropdownItem" onClick={() => duplicateElement()}>
						Duplicate this element
					</ListGroup.Item>
				)}

				{element.type === ElementType.MCQuestionPool && (
					<ListGroup.Item className="dropdownItem" onClick={() => generateQuestions()}>
						Generate questions
					</ListGroup.Item>
				)}
			</ListGroup>

			{isGenerateQuestionsModalShown && element.type === ElementType.MCQuestionPool && (
				<GenerateQuestionsModal
					onHide={() => {
						setGenerateQuestionsModalShown(false);
						onDropdownHide();
					}}
					isShown={isGenerateQuestionsModalShown}
					element={element}
					courseId={courseId}
					pageId={pageId}
				/>
			)}
		</>
	);
};

export default ElementDropdown;
